




















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  import { debounce } from 'ts-debounce'

  import { mapGetters } from 'vuex'

  @Component({ components: { },
    computed:
      mapGetters([
      ])
  })
  export default class Autocomplete extends Vue {
    current:number = 0
    inputText:string = ''
    active:boolean = false
    debounce:number = 300
    inputChangeDebounced:any
    blurDebounced:any
    focusDebounced:any

    // on change of update the input text will be updated
    // the update is the same object as the list of suggenstions
    @Prop()
    update:any

    @Prop()
    suggestions:any

    @Prop()
    nameField:string

    @Prop()
    dropdown:boolean

    mounted () {
      console.log('Autocomplete: mounted hook ')
      this.inputChangeDebounced = debounce(
        () => {
          this.$emit('changed', this.inputText)
        }, this.debounce, false)
      this.blurDebounced = debounce(
        () => {
          this.active = false
          this.$emit('deactivated')
        }, this.debounce, false)
      this.focusDebounced = debounce(
        () => {
          this.active = true
          this.$emit('activated', true)
        }, this.debounce, false)
    }

    // Filtering the suggestion based on the input
    get matches () {
      if (!this.inputText) this.inputText = ''

      var result:any = []
      if (this.suggestions) {
        result = this.suggestions.filter((obj:any) => {
          return obj[this.nameField].indexOf(this.inputText) >= 0
        })
      }
      if (result.length === 0) {
        this.current = -1
      }

      if (this.current >= result.length - 1) {
        this.current = result.length - 1
      }
      return result
    }
    // When enter pressed on the input
    enter () {
      if (this.current >= 0) {
        var emitted = this.matches[this.current]
        this.inputText = emitted[this.nameField]
        this.active = false
        this.$emit('selected', emitted)
      }
    }

    // When up pressed while suggestions are open
    up () {
      if (this.current > 0) {
        this.current--
      }
    }

    // When up pressed while suggestions are open
    down () {
      if (this.current < this.matches.length - 1) {
        this.current++
      }
    }
    onFocus () {
      this.focusDebounced()
    }
    onBlur () {
      this.blurDebounced()
    }
    // For highlighting element
    isActive (index:any) {
      return index === this.current
    }

    // When one of the suggestion is clicked
    suggestionClick (event:any, suggestion:any) {
      this.inputText = suggestion[this.nameField]
      this.$emit('selected', suggestion)
    }

    @Watch('inputText')
    watchInputText () {
      if (this.active) {
        this.inputChangeDebounced()
      }
    }

    @Watch('update')
    watchUpdate () {
      this.inputText = this.update[this.nameField].trim()
    }
    @Watch('dropdown')
    watchDropdown () {
      this.active = true
    }

    onIconClicked () {
      this.inputText = ''
      this.$emit('cleared')
    }
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Autocomplete.vue